import axios from 'axios';
import kylin from '@/utils/kylin';
import adam from '@/utils/adam';
import order from '@/utils/order';
import sweet from '@/utils/sweet';
import cookie from 'js-cookie';
import qs from 'qs';
import browser from '@/utils/browser';
import EncryUtil from '@/utils/encrypt.js';

function getToken () {
    return cookie.get('cookie_user_auth');
}

// 判断环境
function isApp () {
    let programType = window.localStorage.getItem('programType');
    if (browser.versions().platformiOS) {
        return 'IOS';
    } else if (browser.versions().platformAndroid) {
        return 'Android';
    } else if (browser.versions().wxmini) {
        if (programType && programType == 2) {
            return 'miniMk';
        } else {
            return 'mini';
        }
    } else {
        return 'H5';
    }
}

// 获取票务列表
export function GetTicketsList (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/performance/localList'),
        method: 'get',
        headers: {
            'source': isApp(),
            'version': '1.1'
        },
        params
    });
}

// 获取banner列表
export function GetHomeBanners (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/banners'),
        method: 'get',
        params
    });
}

// 获取自定义H5 Banner列表
export function GetBannersMerchant (params) {
    return axios({
        url: merchant.BaseUrl('/merchant/custom/h5/banner'),
        method: 'get',
        params
    });
}

// 巡演列表
export function GetTourList (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/performance/roadList/') + params,
        method: 'get'
    });
}

// 获取推荐演出
export function GetHomeRecommendList () {
    return axios({
        url: kylin.BaseUrl('/kylin/performance/recommendList'),
        method: 'get'
    });
}

// 获取演出预告
export function GetHomeNoticeList (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/performance/noticeList'),
        method: 'get',
        headers: {
            'Authorization': 'Bearer ' + getToken()
        },
        params
    });
}

// 票务详情
export function GetTicketDetail (id, params) {
    let headers = getToken() ? { 'Authorization': 'Bearer ' + getToken() } : { };
    return axios({
        url: kylin.BaseUrl('/kylin/performance/') + id,
        method: 'get',
        headers,
        params
    });
}

//  选择票种时间
export function GetSpecifications (id, params) {
    return axios({
        url: kylin.BaseUrl('/kylin/performance/partner/') + id,
        method: 'get',
        headers: {
            'Authorization': 'Bearer ' + getToken(),
            'source': isApp(),
            'version': '1.1'
        },
        params
    });
}

// 购票信息
export function GetPurchaseDetail (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/performance/payDetail'),
        method: 'get',
        headers: {'Authorization': 'Bearer ' + getToken()},
        params
    });
}

// 缺票登记
export function LackRegister (data) {
    return axios({
        url: kylin.BaseUrl('/kylin/performance/lackRegister'),
        method: 'post',
        headers: {'Authorization': 'Bearer ' + getToken()},
        data: qs.stringify(data)
    });
}

// 获取openid
export function GetOpenId (params) {
    return axios({
        // url: adam.BaseUrl('/adam/wx/oauth2/access_token'),
        url: sweet.BaseUrl('/sweet/wechatLogin/mpOpenId'),
        method: 'get',
        headers: {'Authorization': 'Bearer ' + getToken()},
        params
    });
}
// 获取新裤子想看用户信息
export function getSweetCreate (data) {
    return axios({
        // url: adam.BaseUrl('/adam/wx/oauth2/access_token'),
        url: sweet.BaseUrl('sweet/appletSubMsg/create'),
        method: 'post',
        headers: {'Authorization': 'Bearer ' + getToken()},
        data: qs.stringify(data)
    });
}

// 下单加密
export function TicketPay (data) {
    return axios({
        url: order.BaseUrl('/order/order/pre'),
        method: 'post',
        headers: {
            'Authorization': 'Bearer ' + getToken(),
            'source': isApp(),
            'version': '1.1'
        },
        // data,
        data: EncryUtil.encryptByAES(data)
    });
}

// 订单详情页支付
export function TicketOrderPay (data) {
    return axios({
        url: order.BaseUrl('/order/order/payAgain'),
        method: 'post',
        headers: {
            'Authorization': 'Bearer ' + getToken(),
            'source': isApp(),
            'version': '1.1'
        },
        data
    });
}

// 订单详情页补充入场人
export function SupplementEnter (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/order/supplementEnter'),
        method: 'get',
        headers: {
            'Authorization': 'Bearer ' + getToken()
        },
        params
    });
}

// 支付完成中间页面获取订单状态
export function GetOrderStatus (params) {
    return axios({
        url: order.BaseUrl('/order/order/checkPayment'),
        method: 'get',
        headers: {'Authorization': 'Bearer ' + getToken()},
        params
    });
}

// 票种信息
export function GetPurchaseInfo (params) {
    return axios({
        url: kylin.BaseUrl('/user/ticket'),
        method: 'get',
        headers: {
            'source': isApp(),
            'version': '1.1'
        },
        params
    });
}

// 根据券信息获取演出id
export function GetCouponPerformanceId (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/performance/couponPerformanceId'),
        method: 'get',
        headers: {'Authorization': 'Bearer ' + getToken()},
        params
    });
}

// 根据地址查询运费
export function getShunFengPrice (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/getShunFengPrice/getPrice'),
        method: 'get',
        headers: {'Authorization': 'Bearer ' + getToken()},
        params
    });
}

// 获取快递信息
export function GetExpressInfo (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/performancesExpress/orderRoute/') + params,
        method: 'get',
        headers: {'Authorization': 'Bearer ' + getToken()}
    });
}

// 获取自定义H5 演出列表
export function GetTicketsMerchant (params) {
    return axios({
        url: kylin.BaseUrl('/user/custom/h5/performance'),
        method: 'get',
        params
    });
}

// 获取vip专属演出、商品列表
export function GetVipOnlyProducts (params) {
    return axios({
        url: kylin.BaseUrl('/user/performance/composeExclusiveList'),
        method: 'get',
        params
    });
}

// 获取会员开售状态
export function GetMemberOnsale (params) {
    return axios({
        url: adam.BaseUrl('/adam/member/onsale'),
        method: 'get',
        headers: {'Authorization': 'Bearer ' + getToken()},
        params
    });
}

// 获取退款前详情
export function GetOrderRefundDetails (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/orderRefund/toOrderRefundDetails'),
        headers: {'Authorization': 'Bearer ' + getToken()},
        method: 'get',
        params
    });
}

// 想要退款订单详情
export function getChargesRatioItem (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/orderRefund/getChargesRatioItem2'),
        headers: {'Authorization': 'Bearer ' + getToken()},
        method: 'get',
        params
    });
}

// 提交并申请退款
export function SendOrderRefunds (data) {
    return axios({
        url: kylin.BaseUrl('/kylin/orderRefund/sendOrderRefunds'),
        headers: {'Authorization': 'Bearer ' + getToken()},
        method: 'post',
        data: qs.stringify(data)
    });
}

// 获取退款进度详情
export function GetOrderRefundProgress (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/orderRefund/orderRefundDetails'),
        headers: {'Authorization': 'Bearer ' + getToken()},
        method: 'get',
        params
    });
}

// 退款撤回
export function OrderRefundWithdraw (data) {
    return axios({
        url: kylin.BaseUrl('/kylin/orderRefund/orderRefundWithdraw'),
        headers: {'Authorization': 'Bearer ' + getToken()},
        method: 'post',
        data: qs.stringify(data)
    });
}

// 是否预约演出
export function TicketIsSubscribe (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/performanceOther/isSubscribe'),
        headers: {'Authorization': 'Bearer ' + getToken()},
        method: 'get',
        params
    });
}

// 演出预约
export function TicketSubscribe (data) {
    return axios({
        url: kylin.BaseUrl('/kylin/performanceOther/subscribe'),
        headers: {'Authorization': 'Bearer ' + getToken()},
        method: 'post',
        data: qs.stringify(data)
    });
}
// 获取优先券券列表
export function getKylinCandy (data) {
    return axios({
        url: kylin.BaseUrl('/kylin/performance/kylinCandy'),
        method: 'post',
        headers: {'Authorization': 'Bearer ' + getToken(),
            'Content-Type': 'application/json'
        },
        data
    });
}

//获取AR兑换码
export function GetArcode(params){
  return axios({
    url:kylin.BaseUrl('/kylin/order/orderArCode'),
    method:'get',
    headers: {'Authorization': 'Bearer ' + getToken(),
      'Content-Type': 'application/json'
    },
    params
  })
}

export function getLuckyBag (params) {
    return axios({
        url: kylin.BaseUrl('/kylin/luckyBag'),
        headers: {'Authorization': 'Bearer ' + getToken()},
        method: 'get',
        params
    });
}